export const createServiceRepairSteps = isEstimate => [
    {
        name: 'Type of Request',
        description: isEstimate ? 'Service Estimate' : 'Request Repair',
        finish: true,
        active: false,
    },
    {
        name: 'Select Asset',
        description: '',
        finish: false,
        active: true,
    },
    {
        name: 'Check Duplicates',
        description: '',
        finish: false,
        active: false,
    },
    {
        name: 'Request Details',
        description: '',
        finish: false,
        active: false,
    },
]

export const createEstimateSteps = [
    {
        name: 'Type of Request',
        description: 'Service Estimate',
        finish: true,
        active: false,
    },
    {
        name: 'Select Asset',
        description: '',
        finish: false,
        active: true,
    },
    {
        name: 'Check Duplicates',
        description: '',
        finish: false,
        active: false,
    },
    {
        name: 'Request Details',
        description: '',
        finish: false,
        active: false,
    },
]

export const createPartsRequestSteps = [
    {
        name: 'Type of Request',
        description: 'Parts Quote',
        finish: true,
        active: false,
    },
    {
        name: 'Select Asset',
        description: '',
        finish: false,
        active: true,
    },
    {
        name: 'Request Details',
        description: '',
        finish: false,
        active: false,
    },
]

export const createServiceStepsInitial = [
    {
        name: 'Choose Type of Request',
        description: 'Request Repair',
        finish: false,
        active: true,
    },
    {
        name: 'Select Asset',
        description: '',
        finish: false,
        active: false,
    },
    {
        name: 'Check Duplicates',
        description: '',
        finish: false,
        active: false,
    },
    {
        name: 'Request Details',
        description: '',
        finish: false,
        active: false,
    },
]

export const createPartsStepsInitial = [
    {
        name: 'Choose Type of Request',
        description: 'Parts Quote',
        finish: false,
        active: true,
    },
    {
        name: 'Select Asset',
        description: '',
        finish: false,
        active: false,
    },
    {
        name: 'Request Details',
        description: '',
        finish: false,
        active: false,
    },
]
